// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2jn6e","right":"Footer_right__276x6","buttons":"Footer_buttons__1mAXl"};